<template>
    <div>
        <v-dialog v-model="dialog" :max-width="!showCheckboxes ? 800 : 550">
            <LabeledCard :label="$t('Фильтрация')">
                <slot>
                    <v-container fluid class="pt-5">
                        <v-form ref="uploadsDetailsFilter">
                            <v-row dense no-gutters>
                                <v-col cols="12" :sm="!showCheckboxes ? 8 : 12">
                                    <v-row dense align="center" class="mb-5" no-gutters>
                                        <v-col cols="12" sm="3">
                                            <span class="label font-weight-bold">{{ $t('ID ПУТЭ') }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="5" class=" pr-1">
                                            <v-text-field
                                                v-model="filterData.meterID"
                                                maxlength="9"
                                                dense
                                                :persistent-hint="true"
                                                :hint="this.$t('Введите полное значение')"
                                                outlined
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense align="center" class="mb-5" no-gutters>
                                        <v-col cols="12" sm="3">
                                            <span class="label font-weight-bold">{{ $t('Номер ПУТЭ') }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="5" class=" pr-1">
                                            <v-text-field
                                                dense
                                                outlined
                                                v-model="filterData.meterNumber"
                                                :persistent-hint="true"
                                                :hint="this.$t('Введите полное или частичное значение')"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row dense align="center" no-gutters class="pt-5">
                                        <v-col cols="12" sm="3">
                                            <span
                                                style="position: relative;"
                                                :class="{ 'label font-weight-bold': true, 't-15px': $vuetify.breakpoint.smAndUp }"
                                                >{{ $t('Дата начала') }}</span
                                            >
                                        </v-col>
                                        <v-col cols="12" sm="9">
                                            <v-row no-gutters>
                                                <v-col cols="12" sm="6" class=" pr-1">
                                                    <DatePicker
                                                        :class="{ 'pb-2': $vuetify.breakpoint.xsOnly }"
                                                        hideDetails
                                                        :label="$t('Дата с')"
                                                        class="date-filter"
                                                        dense
                                                        outlined
                                                        v-model="filterData.loadDateFrom"
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="6" class=" pr-1">
                                                    <DatePicker
                                                        :label="$t('Дата по')"
                                                        dense
                                                        class="date-filter"
                                                        :hideDetails="false"
                                                        :rules="[checkLoadDate]"
                                                        outlined
                                                        v-model="filterData.loadDateUntil"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense align="center" no-gutters>
                                        <v-col cols="12" sm="3">
                                            <div
                                                style="position: relative; "
                                                :class="{ 'label font-weight-bold': true, 't-15px': $vuetify.breakpoint.smAndUp }"
                                            >
                                                {{ $t('Дата окончания') }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12" sm="9">
                                            <v-row dense no-gutters>
                                                <v-col cols="12" sm="6" class="pr-1">
                                                    <DatePicker
                                                        :class="{ 'pb-2': $vuetify.breakpoint.xsOnly }"
                                                        hideDetails
                                                        :label="$t('Дата с')"
                                                        class="date-filter"
                                                        dense
                                                        outlined
                                                        v-model="filterData.proccecedDateFrom"
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="6" class="pr-1">
                                                    <DatePicker
                                                        :label="$t('Дата по')"
                                                        :hideDetails="false"
                                                        :rules="[checkStatusDate]"
                                                        class="date-filter"
                                                        dense
                                                        outlined
                                                        v-model="filterData.proccecedDateUntil"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="1" class="d-flex justify-center" v-if="$vuetify.breakpoint.smAndUp && !showCheckboxes">
                                    <!-- <v-divider  vertical style="border-color:#363e59" /> -->
                                </v-col>
                                <v-col v-if="!showCheckboxes" cols="12" sm="3">
                                    <p class="label font-weight-bold" style="margin-top:15.5px">{{ $t('Статус загрузки') }}</p>
                                    <v-checkbox
                                        :color="$vuetify.theme.themes.dark.primary"
                                        @change="(filterData.checkbox2 = false), (filterData.checkbox3 = false)"
                                        v-model="filterData.checkbox1"
                                        :label="$t('Все')"
                                        hide-details
                                    />
                                    <v-checkbox
                                        :color="$vuetify.theme.themes.dark.primary"
                                        @change="(filterData.checkbox1 = false), (filterData.checkbox3 = false)"
                                        v-model="filterData.checkbox2"
                                        :label="$t('Без ошибки')"
                                        hide-details
                                    />
                                    <v-checkbox
                                        :color="$vuetify.theme.themes.dark.primary"
                                        @change="(filterData.checkbox1 = false), (filterData.checkbox2 = false)"
                                        v-model="filterData.checkbox3"
                                        :label="$t('С ошибкой')"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </v-form>

                        <v-row dense class="pt-3">
                            <v-col cols="12" sm="6"></v-col>
                            <v-col cols="12" sm="3">
                                <v-btn @click="handleCancel" outlined :color="$vuetify.theme.themes.dark.primary" class="rounded-btn mr-1 w100">{{
                                    $t('Отмена')
                                }}</v-btn>
                            </v-col>
                            <v-col cols="12" sm="3" class="d-flex justify-end">
                                <v-btn class="rounded-btn w100" @click="filterItems" dark :color="$vuetify.theme.themes.dark.primary">{{
                                    $t('Применить')
                                }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </slot>
            </LabeledCard>
        </v-dialog>
        <v-btn :title="$t('Фильтр')" icon :color="$vuetify.theme.themes.dark.primary" class="mr-1" @click="dialog = true">
            <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn :title="$t('Очистить фильтр')" icon color="red" :disabled="customDisable" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
        </v-btn>
    </div>
</template>

<script>
import LabeledCard from '@/components/ui/LabeledCard';
import DatePicker from '@/components/ui/DatePicker';
import { getFilterArray, getFilterArrayWithDates } from '@/utils/filter.util';
import { isFilterEmpty, cloneObject } from '@/utils';

import moment from 'moment';

export default {
    props: ['showCheckboxes', 'customDisable', 'value'],
    components: { DatePicker, LabeledCard },
    data: () => ({
        filterData: {
            checkbox1: false,
            checkbox2: false,
            checkbox3: false,
            loadDateFrom: null,
            loadDateUntil: null,
            proccecedDateFrom: null,
            proccecedDateUntil: null,
            meterID: null,
            meterNumber: null
        },
        dialog: false,

        error_text: null
    }),
    watch: {
        value(val) {
            this.filterData = cloneObject(val);
        },
        checkbox1(val) {
            if (val) {
                this.checkbox2 = false;
                this.checkbox3 = false;
            }
        },
        checkbox2(val) {
            if (val) {
                this.checkbox1 = false;
                this.checkbox3 = false;
            }
        },
        checkbox3(val) {
            if (val) {
                this.checkbox2 = false;
                this.checkbox1 = false;
            }
        }
    },
    computed: {
        checkLoadDate(val) {
            if (this.filterData.loadDateFrom && this.filterData.loadDateUntil) {
                return moment(this.filterData.loadDateFrom).isAfter(this.filterData.loadDateUntil) ? this.$t("'Дата по' не может быть раньше 'Дата с'") : true;
            } else return true;
        },
        checkStatusDate() {
            if (this.filterData.proccecedDateFrom && this.filterData.proccecedDateUntil) {
                return moment(this.filterData.proccecedDateFrom).isAfter(this.filterData.proccecedDateUntil)
                    ? this.$t("'Дата по' не может быть раньше 'Дата с'")
                    : true;
            } else return true;
        }
    },
    methods: {
        getErrorText() {
            if (this.filterData.checkbox1) {
                this.error_text = null;
            } else if (this.filterData.checkbox2) {
                this.error_text = 1;
            } else if (this.filterData.checkbox3) {
                this.error_text = 2;
            }
        },
        filterItems() {
            if (!this.$refs.uploadsDetailsFilter.validate()) return;
            this.getErrorText();
            const items = this.filterData;
            const obj = {
                date_consumption_begin: [items.loadDateFrom, items.loadDateUntil],
                date_consumption_end: [items.proccecedDateFrom, items.proccecedDateUntil],
                meter_rid: items.meterID ? Number(items.meterID.match(/\d+/g).join('')) : null,
                meter_number: items.meterNumber,
                error_text: this.error_text
            };

            const processedArrayWithFilters = getFilterArray(obj);
            let arrayFilter = {
                where: [...processedArrayWithFilters]
            };
            this.$emit('filter', arrayFilter);
            this.$emit('saveFilter', cloneObject(items));
            this.dialog = false;
        },
        clearFilter() {
            this.$emit('filter', {});
            this.$emit('saveFilter', {});
            this.$forceUpdate();
        },
        handleCancel() {
            this.dialog = false;
            this.filterData = cloneObject(this.value);
        }
    }
};
</script>

<style>
.date-filter .v-input .v-input__control .v-text-field__details .v-messages {
    min-height: 35px !important;
}
.v-application .pr-14 {
    padding-right: 0px !important;
}
</style>
